import { css } from "@emotion/react";

import { colors } from "@styles";

export const textLeft = css`
  text-align: left;
`;

export const form = css`
  width: 100%;
  ${textLeft}
`;

export const flex = css`
  display: flex;
`;

export const row = css`
  ${flex}
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const link = css`
  text-decoration: underline;
  color: ${colors.grey.darkFamily.dark};
`;

export const marginBottom = css`
  margin-bottom: 1rem;
`;
